/** The element a message is drawn in, so the transcript can be scrolled to it. */
export function messageElementId(messageId: string): string {
  return `message-${messageId}`;
}
